import { render, staticRenderFns } from "./certificateapplication.vue?vue&type=template&id=61042cf9&scoped=true"
import script from "./certificateapplication.vue?vue&type=script&lang=js"
export * from "./certificateapplication.vue?vue&type=script&lang=js"
import style0 from "./certificateapplication.vue?vue&type=style&index=0&id=61042cf9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61042cf9",
  null
  
)

export default component.exports